import { render, staticRenderFns } from "./PlagueMonitoringTable.vue?vue&type=template&id=254ea65e&scoped=true&lang=html&"
import script from "./PlagueMonitoringTable.vue?vue&type=script&lang=js&"
export * from "./PlagueMonitoringTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254ea65e",
  null
  
)

export default component.exports